import type { Theme } from "@mui/material";
import type { SxProps } from "@mui/system";
import type { Property } from "csstype";

export const statusStyles = {
	base: {
		py: 0.5,
		px: 1.5,
		borderRadius: "8px",
		display: "inline-block",
		alignSelf: "flex-start",
		fontSize: "0.75rem",
		lineHeight: 1.2,
		fontWeight: "bold",
	},
	pending: {
		bgcolor: "#F5A10666",
		color: "#BA7A06",
	},
	approved: {
		bgcolor: "#1EBA6466",
		color: "#168D4C",
	},
	declined: {
		bgcolor: "#E71C004D",
		color: "#B01500",
	},
	closed: {
		bgcolor: "#0000FF4D",
		color: "#4A4A8C",
	},
} as const satisfies Record<string, SxProps>;

export const statusPendingExtraInfoColor = "primary.main" as const satisfies Property.Color;

export const statusPendingExtraInfoStyles: SxProps<Theme> = {
	fontSize: statusStyles.base.fontSize,
	fontWeight: statusStyles.base.fontWeight,
	color: statusPendingExtraInfoColor,
} as const satisfies SxProps<Theme>;
